import { RequestService, type RequestOptions } from '../request-service';
import type {
  QueryBranchesRequest,
  QueryBranchesResponse,
} from '@wix/ambassador-editor-branches-v1-branch/types';
import { Type } from '@wix/ambassador-editor-branches-v1-branch/types';
import type RpcModule from '@wix/ambassador-editor-branches-v1-branch/rpc';
import type HttpModule from '@wix/ambassador-editor-branches-v1-branch/http';
import { SiteBranches } from './site-branches';

type RpcModuleType = typeof RpcModule;
type HttpModuleType = typeof HttpModule;

export class SiteBranchesService extends RequestService<
  RpcModuleType,
  HttpModuleType
> {
  protected async rpcModule(): Promise<RpcModuleType> {
    return import('@wix/ambassador-editor-branches-v1-branch/rpc');
  }

  protected async httpModule(): Promise<HttpModuleType> {
    return import('@wix/ambassador-editor-branches-v1-branch/http');
  }

  public async query(payload?: { types?: Type[] }, options?: RequestOptions) {
    const types = payload?.types || [];

    const response = await this.request<
      QueryBranchesRequest,
      QueryBranchesResponse
    >({
      methodName: 'queryBranches',
      payload: {
        query: {
          filter: {
            type: types,
          },
        },
      },
      options,
    });

    const branches = response.branches || [];
    return new SiteBranches(branches);
  }

  public async getUserBranches(options?: RequestOptions) {
    return this.query({ types: [Type.USER] }, options);
  }
}
